// Fallback rendered by Sentry.ErrorBoundary at main.tsx when an unhandled
// render error reaches the root. Dependency-free inline styling so it still
// works if the failure is in our own UI layer or Tailwind hasn't loaded.

interface SentryFallbackProps {
  error: unknown
  componentStack?: string
  resetError: () => void
}

export function SentryFallback({ error, resetError }: SentryFallbackProps) {
  const message =
    error instanceof Error ? error.message :
    typeof error === 'string' ? error :
    'An unexpected error occurred.'

  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0a0a0a',
        color: '#ffffff',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 480, textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 12px' }}>
          Brands Meet Creators — something broke
        </h1>
        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.55)', margin: '0 0 8px' }}>
          The error has been reported automatically. Try reloading; if it persists,
          email support@brandsmeetcreators.com with the message below.
        </p>
        <pre
          style={{
            background: '#141414',
            border: '1px solid rgba(255,255,255,0.08)',
            color: 'rgba(255,255,255,0.55)',
            fontSize: 12,
            padding: 12,
            borderRadius: 6,
            overflowX: 'auto',
            textAlign: 'left',
            margin: '16px 0',
          }}
        >
          {message}
        </pre>
        <button
          onClick={resetError}
          style={{
            background: '#E91E8C',
            color: '#fff',
            border: 'none',
            padding: '10px 20px',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          Try again
        </button>
      </div>
    </div>
  )
}
